module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"task":{"completed":"Task has been completed."},"successMessage":"Success!","candidate":{"emailQuestion":"What is the candidate\u0027s email?","emailAlreadyRegistered":"This email is already registered","label":"Candidate email"},"confirm":"Confirm you\u0027ve completed the actions above before completing this task.","buttons":{"proceed":"Proceed"}}}')
  delete Component.options._Ctor
}
